import { render, staticRenderFns } from "./FlagCategoryTournament.vue?vue&type=template&id=7bf5c5e0&scoped=true"
import script from "./FlagCategoryTournament.vue?vue&type=script&lang=js"
export * from "./FlagCategoryTournament.vue?vue&type=script&lang=js"
import style0 from "./FlagCategoryTournament.vue?vue&type=style&index=0&id=7bf5c5e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf5c5e0",
  null
  
)

export default component.exports